"use client";

import { newsContextSchema, NewsListElement, NewsContext } from "@vereinsheim/backend-types/src/news";
import { getDateWithDayLong, getTime } from "@/helpers/dateHelper";
import Link from "next/link";
import Edit2 from "@/assets/icon/edit-2.svg";
import {
  pwaNewsClubEditPath,
  pwaNewsClubPath,
  pwaNewsTeamEditPath,
  pwaNewsTeamPath,
  pwaTeamPath
} from "@/utils/urlHelper";
import { useAbility } from "@/app/pwa/lib/ability-context";
import { subject } from "@casl/ability";
import { useTeam } from "@/app/pwa/lib/pwa-context";
import { getTeamTypeName } from "@/helpers/teamHelpers";
import TeamTag from "../team/TeamTag";

type NewsElementProps = {
  news: NewsListElement,
  className?: string,
  teamName?: string,
  listContext?: NewsContext
};

export function NewsElement(
  {
    news,
    className,
    listContext
  }: NewsElementProps) {
  const editPath = news.newsContext == newsContextSchema.enum.Club ? pwaNewsClubEditPath(news._id) : pwaNewsTeamEditPath(news.contextId, news._id);
  const ability = useAbility();

  const team = useTeam(news.newsContext === newsContextSchema.enum.Team ? parseInt(news.contextId) : undefined);
  
  return (
    <div className={`${className}`}> 
      {listContext === newsContextSchema.enum.Club && team?.Id &&
        <div className="pt-2">
          <TeamTag href={pwaTeamPath(team.Id?.toString())} team={team} />
        </div>
      }
      <Link href={news.newsContext == "Club" ? pwaNewsClubPath(news._id) : pwaNewsTeamPath(news._id, news.contextId)}className={`rounded block interactive-cell p-2 -mx-2`}>
          <div className="flex flex-col">
          
              <h4 className="text-lg font-semibold">{news.title}</h4>
              <div className="break-anywhere rich-text line-clamp-4" dangerouslySetInnerHTML={{ __html: news.newsText ?? "" }}></div>
            
            
          <div className="flex justify-between items-baseline">
            <time className="text-muted"
                  dateTime={new Date(news.releaseDate).toISOString()}>{getDateWithDayLong(news.releaseDate)}, {getTime(news.releaseDate)}</time>
            <div className="flex-grow hidden @md:block w-0"></div>
          </div> 
          </div>
        </Link>
      </div>
  );
}

export function NewsDetailElement({
  news,
  // className,
  listContext

}: NewsElementProps) {
  const editPath = news.newsContext == newsContextSchema.enum.Club ? pwaNewsClubEditPath(news._id) : pwaNewsTeamEditPath(news.contextId, news._id);
  const ability = useAbility();

  const team = useTeam(news.newsContext === newsContextSchema.enum.Team ? parseInt(news.contextId) : undefined);

  return <>
    <div className="flex flex-col">
          
          <h3 className="text-lg font-semibold">{news.title}</h3>
          <div className="break-anywhere rich-text" dangerouslySetInnerHTML={{ __html: news.newsText ?? "" }}></div>
        
        
      <div className="flex justify-between items-baseline">
        <time className="text-muted"
              dateTime={new Date(news.releaseDate).toISOString()}>{getDateWithDayLong(news.releaseDate)}, {getTime(news.releaseDate)}</time>
        <div className="flex-grow hidden @md:block w-0"></div>
      </div> 
      </div>

      {listContext === newsContextSchema.enum.Club && team?.Id &&
          <Link href={pwaTeamPath(team.Id?.toString())}
                className="bg-gray-900 text-gray-50 rounded px-1.5 font-bold uppercase pb-px">
            {getTeamTypeName(team)}
          </Link>
        }
        {ability.can("update", subject("News", { contextId: news.contextId, newsContext: news.newsContext })) &&
            <div className="mt-2">
              <Link href={editPath} className="button button--link-secondary button--inline" color="link-secondary"><Edit2
                className="mr-blank" />Bearbeiten</Link>
            </div>
        }
  </>
}
